import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from '../Elements/Banner';
import OurProject4 from '../Elements/OurProject4';

var bnrimg = require('./../../images/banner/2.jpg');

const filters = [
    { label: "Construction", filter: ".cat-1" },
    { label: "Renovation", filter: ".cat-2" },
    { label: "Outdoor", filter: ".cat-3" },
    { label: "Interiors", filter: ".cat-4" },
    { label: "Consulting", filter: ".cat-5" },
    
];

const projects = [
    {
        thumb: require('./../../images/projects/portrait/img2.jpeg'),
        image: require('./../../images/projects/portrait/img2.jpeg'),
        title: 'New Italian Embassy Islamabad',
        description: `Embassy of Italy, Diplomatic Enclave, Islamabad`,
        filter: 'cat-1',
        url:'/currentProject1'
    },
    {
        thumb: require('./../../images/projects/portrait/nova 1.png'),
        image: require('./../../images/projects/portrait/nova 1.png'),
        title: 'Nova City',
        description: `MPQ`,
        filter: 'cat-1',
        url: '/housing1'
    },
    {
        thumb: require('./../../images/projects/portrait/corporate 5 (1).png'),
        image: require('./../../images/projects/portrait/corporate 5 (1).png'),
        title: 'Corporate 5',
        // description: `We are so busy watching out for what's just ahead of us that we don't take the time to enjoy where we are.`,
        filter: 'cat-1',
        url: '/currentProject2'
    },
    {
        thumb: require('./../../images/projects/portrait/atyrau6.JPG'),
        image: require('./../../images/projects/portrait/atyrau6.JPG'),
        title: 'Atyrau-Astrakhan Lot 2',
        // description: `We are so busy watching out for what's just ahead of us that we don't take the time to enjoy where we are.`,
        filter: 'cat-1',
        url: '/currentProject3'
    },
    {
        thumb: require('./../../images/projects/portrait/balkhash5.jpg'),
        image: require('./../../images/projects/portrait/balkhash5.jpg'),
        title: 'Balkhash-Burylbaital Lot 3',
        // description: `We are so busy watching out for what's just ahead of us that we don't take the time to enjoy where we are.`,
        filter: 'cat-1',
        url: '/currentProject4'
    },
]

var bnrimg = require('./../../images/banner/b1.png');

class CurrentProjects extends React.Component {
    
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    
    render() {
        return (
            <>
                <Header />
                <Banner title="BROAD VISION. CAREFUL THOUGHT. HAND-CRAFTED DESIGN." pagename="Current Projects" bgimage={bnrimg}/>
                <div className="page-content">
                {/* <Banner title="Always dedicated and devoted" pagename="Project Grid" bgimage={bnrimg}/> */}
                    
                    {/* SECTION CONTENT START */}
                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            {/* PAGINATION START */}
                            <div className="filter-wrap p-b30 text-center">
                                {/* <ul className="filter-navigation inline-navigation masonry-filter link-style  text-uppercase">
                                    <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                    {filters.map((item, index) => (
                                    <li key={index}><NavLink to={"#"} data-filter={item.filter} data-hover={item.label}>{item.label}</NavLink></li>
                                    ))} 
                                </ul> */}
                            </div>
                            {/* PAGINATION END */}
                            {/* GALLERY CONTENT START */}
                            <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                                {projects.map((item, index) => (
                                    <div key={index} className={`${item.filter} masonry-item col-md-4 col-sm-6 m-b30`}>
                                        <div className="image-effect-two hover-shadow">
                                            <img src={item.thumb} alt="" />
                                            <div className="figcaption">
                                                <h4 className="mt-tilte">{item.title}</h4>
                                                <p>{item.description}</p>
                                                <NavLink to={item.url} className="read-more site-button btn-effect">Read More</NavLink>
                                                <a className="mfp-link" href={item.image}>
                                                    <i className="fa fa-arrows-alt" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                
                            </div>
                            {/* GALLERY CONTENT END */}
                            {/* <div className="m-t50 text-center">
                                <NavLink to={"#"} className="site-button btn-effect">Load More</NavLink>
                            </div> */}
                        </div>
                    </div>
                    {/* SECTION CONTENT END  */}
                </div>

                <Footer />
            </>
        );
    };
};

export default CurrentProjects;